// Build a lookup of returnRequest by orderItemId so order item rows
// can render a "Return requested" badge or hide the Return button.
export const indexReturnsByItem = (returns = []) => {
  const map = {};
  returns.forEach((r) => {
    if (r.orderItemId) map[r.orderItemId] = r;
  });
  return map;
};

const ORDER_STATUS_LABELS = {
  processing: 'Processing',
  confirmed: 'Confirmed',
  shipped: 'Shipped',
  out_for_delivery: 'Out for Delivery',
  delivered: 'Delivered',
  cancelled: 'Cancelled',
};

export const formatOrderStatus = (status) =>
  ORDER_STATUS_LABELS[String(status || '').toLowerCase()] || 'Processing';

export const mapOrders = (rawOrders = [], returnsByItem = {}) =>
  rawOrders.map((o) => ({
    id: o.orderId,
    date: o.createdAt,
    confirmedAt: o.confirmedAt,
    shippedAt: o.dispatchedAt,
    deliveredAt: o.deliveredAt,
    shippingCountry: o.shippingCountry,
    status: formatOrderStatus(o.status),
    rawStatus: o.status,
    items: (o.items || []).map((item) => ({
      itemId: item.id,
      bookId: item.bookId,
      title: item.title,
      author: item.author,
      image: item.image,
      qty: item.quantity,
      price: parseFloat(item.price),
      taxRate: item.taxRate != null ? Number(item.taxRate) : null,
      taxAmount: item.taxAmount != null ? Number(item.taxAmount) : null,
      taxableAmount: item.taxableAmount != null ? Number(item.taxableAmount) : null,
      isPreorder: Boolean(item.isPreorder),
      releaseDate: item.releaseDate,
      returnable: item.book?.returnable,
      returnWindowDays: item.book?.returnWindowDays,
      internationalReturnWindowDays: item.book?.internationalReturnWindowDays,
      returnRequest: returnsByItem[item.id] || null,
    })),
    total: parseFloat(o.finalAmount),
    subtotal: parseFloat(o.total),
    discount: parseFloat(o.discount || 0),
    taxAdded: Number(o.taxAdded || 0),
    taxAmount: Number(o.taxAmount || 0),
    address: o.shippingAddress,
    paymentMethod: o.paymentMethod,
    paymentStatus: o.paymentStatus,
    razorpayOrderId: o.razorpayOrderId,
    razorpayPaymentId: o.razorpayPaymentId,
    paypalAmountUsd: o.paypalAmountUsd != null ? parseFloat(o.paypalAmountUsd) : null,
    paypalExchangeRate:
      o.paypalExchangeRate != null ? parseFloat(o.paypalExchangeRate) : null,
    orderCurrencyCode: o.orderCurrencyCode || 'INR',
    exchangeRateUsed: o.exchangeRateUsed != null ? parseFloat(o.exchangeRateUsed) : null,
    deliveryEstimate: o.deliveryEstimate,
  }));
